import routeName from '../constant';
import aplCatlCode from '@/json/aplCatlCode';
import { guideRoutes } from '@/utils/guideRoutes';
import codeList from '@/json/codeList';
const aplCatl = aplCatlCode.CREDIT_CARD_EXP;
const code = codeList.CREDIT_CARD_EXP;

export const routesCreditCard = [
    {
        path: 'credit-card-policy',
        name: routeName.CREDITCARD_POLICY,
        component: () => import('@/views/aplCatlCreditCardExp/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: '保單信用卡列表', leaveAlert: true, code, pageTitle: '信用卡效期延長', unableBack: true },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.CONFIRM_DATA, routeName.EDIT_TEL_MAIL];
            const guideRoute = guideRoutes(from, whiteList, true, aplCatl);
            next(guideRoute);
        },
    },
    {
        path: 'credit-card-expiry-date',
        name: routeName.CREDITCARD_EXPIRY_DATE,
        component: () => import('@/views/aplCatlCreditCardExp/expirationDate/Index.vue'),
        meta: { auth: true, metaTitle: '信用卡效期有效年月', leaveAlert: true, code, pageTitle: '信用卡效期延長', unableBack: true },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.CREDITCARD_POLICY];
            const guideRoute = guideRoutes(from, whiteList, true, aplCatl);
            next(guideRoute);
        },
    },
];
